(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["contact-form"] && !Shopify.designMode) return;
  try {
    (function() {
    const forms = document.querySelectorAll('.contact-form__form[data-form-id]');
    
    forms.forEach(function(form) {
      const formId = form.getAttribute('data-form-id');
      const emailInput = form.querySelector('#ContactForm-email');
      const errorElement = form.querySelector('#ContactForm-email-error');
    
      if (!emailInput || !errorElement) return;

      function validateEmail() {
        const email = emailInput.value.trim();
        
        if (emailInput.validity.valueMissing) {
          errorElement.textContent = 'Email address is required.';
          emailInput.setAttribute('aria-invalid', 'true');
          return false;
        } else if (emailInput.validity.typeMismatch || emailInput.validity.patternMismatch) {
          errorElement.textContent = 'Please enter a valid email address.';
          emailInput.setAttribute('aria-invalid', 'true');
          return false;
        } else {
          errorElement.textContent = '';
          emailInput.removeAttribute('aria-invalid');
          return true;
        }
      }

      emailInput.addEventListener('blur', validateEmail);
      emailInput.addEventListener('input', function() {
        if (emailInput.value.trim() && emailInput.validity.valid) {
          errorElement.textContent = '';
          emailInput.removeAttribute('aria-invalid');
        }
      });

      form.addEventListener('submit', function(e) {
        if (!validateEmail()) {
          e.preventDefault();
          emailInput.focus();
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
